import React from "react";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IReceiptsReturns, IMeta, ICommonState } from "models/.";
import { connect } from "../../reduxConnector";
import ReceiptsActions from "./actions";
import { columns } from "./columns";
import ReceiptReturnSearch from "./partials/ReceiptReturnSearch";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getReceipts: (meta?: IMeta) => void;
  receipts: IReceiptsReturns[];
  meta: IMeta;
  history: History;
  roleIds: any[];
}

interface IState extends ICommonState {
  selectedData: any;
}

class ReceiptsReturns extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: []
    };
  }

  public handleSelect = selectedOption => {
    const { checkedRows, selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _(checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    value === "gelezen" && markAsRead(ids, "ReceiptAndReturn");
    value === "ongelezen" && markAsUnread(ids, "ReceiptAndReturn");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "RECEIPTS_AND_RETURNS");
      markAsRead(ids, "ReceiptAndReturn");
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = data => {
    this.setState({ columnsCopy: data });
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.receipts,
        checkedRows,
        this.state.selectedData
      )
    });
  };

  public render() {
    const { getReceipts, receipts, meta, roleIds } = this.props;
    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      checkedRows
    } = this.state;

    return (
      <div id="receipts-page">
        <FormattedMessage id="RECEIPTS_AND_RETURNS_HEADER" tagName="h1" />
        <ReceiptReturnSearch
          meta={meta}
          onSearch={getReceipts}
          roleIds={roleIds}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getReceipts({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          selectedOption={selectedOption}
          entityName="receipts-returns"
        />
        <Table
          columns={columnsCopy}
          dataSource={receipts}
          meta={meta}
          onQueryChange={getReceipts}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.receiptsReturns}
        />
        <FieldChooser
          name="ontvangst_retouren"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    receipts: state.receiptsReturns.items,
    meta: state.receiptsReturns.meta,
    roleIds: state.app.roleIds
  }),
  {
    getReceipts: ReceiptsActions.getReceipts
  }
)(ReceiptsReturns);
